<template>
  <div>
    <section class="banner" style="display: none">
      <el-image
        fit="cover"
        :src="$common.getResourceUrl('pcweb/index/banner.jpg')"
      />
    </section>

    <section
      class="section-01"
      :style="{
        backgroundImage:
          'url(' + $common.getResourceUrl('pcweb/index/sec-bg.png') + ')',
        display: 'none',
      }"
    >
      <div class="section-main">
        <div class="section-head">
          <div class="title">
            <span>
              <span class="dot"></span>
              平板绘画学习 就来{{ $domain.name }}
              <span class="dot rev"></span>
            </span>
          </div>
          <div class="desc">深耕在线教育多年 专注成人、少儿 0基础艺术教育</div>
        </div>
        <div class="section-content">
          <div class="panel-list">
            <div>
              <div>200<span>万</span></div>
              <div>在线累计报名学员</div>
            </div>
            <div>
              <div>600<span>人</span></div>
              <div>师资教研团队</div>
            </div>
            <div>
              <div>97.8<span>%</span></div>
              <div>学员好评率</div>
            </div>
            <div>
              <div>1000<span>+</span></div>
              <div>3200万累计注册学员</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-02">
      <div class="section-main">
        <div class="section-head">
          <div class="title">
            <span>
              <span class="dot"></span>
              在线教学服务 助力您学习更有效
              <span class="dot rev"></span>
            </span>
          </div>
          <!-- <div class="desc">3v1师资服务体系 实力+服务完美结合学习无忧</div> -->
        </div>
        <div
          class="section-content"
          @mouseleave="section02Intval"
          @mousemove="section02Intval(false)"
        >
          <div class="left">
            <div
              v-for="(i, k) in section02"
              :key="k"
              :class="{ active: section02Index == k }"
              @mouseover="section02Index = k"
            >
              <label>{{ i.label }}</label>
              {{ i.title }}
            </div>
          </div>
          <div class="right">
            <el-image
              v-for="(i, k) in section02"
              :key="k"
              :class="{ active: section02Index == k }"
              fit="cover"
              :src="$common.getResourceUrl(i.image)"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="section-03">
      <div class="section-main">
        <div class="section-head">
          <div class="title">
            <span>
              <span class="dot"></span>
              选出懂艺术，更懂学员的老师
              <span class="dot rev"></span>
            </span>
          </div>
          <!-- <div class="desc">资历能力兼备 保证高水平教学质量</div> -->
        </div>
        <div class="section-content">
          <div class="flex">
            <div class="left">
              <div style="left: 30px">
                <div class="icon">
                  <el-image
                    fit="cover"
                    :src="$common.getResourceUrl('pcweb/index/t_ico_1.jpg')"
                  />
                </div>
                <div class="main">
                  <div>科班出身</div>
                  <div>科班院校毕业，多年从业经历</div>
                </div>
              </div>
              <div>
                <div class="icon">
                  <el-image
                    fit="cover"
                    :src="$common.getResourceUrl('pcweb/index/t_ico_3.jpg')"
                  />
                </div>
                <div class="main">
                  <div>系统学习</div>
                  <div>插画知识系统输出授课</div>
                </div>
              </div>
            </div>
            <div class="center">
              <el-image
                fit="cover"
                :src="$common.getResourceUrl('pcweb/index/teachers.jpg')"
              />
            </div>
            <div class="right">
              <div style="left: -20px">
                <div class="icon">
                  <el-image
                    fit="cover"
                    :src="$common.getResourceUrl('pcweb/index/t_ico_2.jpg')"
                  />
                </div>
                <div class="main">
                  <div>严格筛选</div>
                  <div>通过多轮筛选，精选优质人才</div>
                </div>
              </div>
              <div>
                <div class="icon">
                  <el-image
                    fit="cover"
                    :src="$common.getResourceUrl('pcweb/index/t_ico_4.jpg')"
                  />
                </div>
                <div class="main">
                  <div>资历深厚</div>
                  <div>拥有线上教学经验</div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 100px"></div>
          <!-- <div class="bottom-line">
            <div>经验丰富的师资队伍</div>
            <span> <i /><i /><i /><i /> </span>
          </div> -->
        </div>
      </div>
    </section>

    <section class="section-04">
      <div class="section-main">
        <div class="section-head">
          <div class="title">
            <span>
              <span class="dot"></span>
              来看看{{ $domain.company_short.substring(0, 2) }}学员的优秀作品
              <span class="dot rev"></span>
            </span>
          </div>
          <div class="desc">在{{ $domain.company_short }}见证自己的成长</div>
        </div>
        <div
          class="section-content"
          @mouseleave="section04Intval"
          @mousemove="section04Intval(false)"
        >
          <div class="left">
            <el-image
              v-for="(i, k) in section04"
              :key="k"
              :class="{ active: section04Index == k }"
              fit="contain"
              :src="$common.getResourceUrl(i.image)"
            />
          </div>
          <div class="right">
            <div class="list">
              <div
                v-for="(i, k) in section04"
                :key="k"
                class="item"
                :class="{ active: section04Index == k }"
                @mouseover="section04Index = k"
              >
                <div class="note">{{ i.note }}</div>
                <div class="user">
                  <div class="head">
                    <el-image
                      fit="cover"
                      :src="$common.getResourceUrl(i.head)"
                    />
                  </div>
                  <div class="name">{{ i.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-05">
      <div class="section-main">
        <div class="section-head">
          <div class="title">
            <span>
              <span class="dot"></span>
              为什么选择{{ $domain.company_short }}
              <span class="dot rev"></span>
            </span>
          </div>
          <!-- <div class="desc">来小白学画，学的快！学的稳！</div> -->
        </div>
        <div class="section-content">
          <div v-for="(i, k) in section05" :key="k" class="item">
            <div class="icon">
              <el-image fit="cover" :src="$common.getResourceUrl(i.icon)" />
            </div>
            <div class="title">{{ i.title }}</div>
            <div class="desc">{{ i.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-06" style="display: none">
      <div class="section-main">
        <div class="section-head">
          <div class="title">
            <span>
              <span class="dot"></span>
              名师引领 打造高效课堂
              <span class="dot rev"></span>
            </span>
          </div>
          <div class="desc">深耕在线教育 彰显品牌影响力</div>
        </div>
        <div class="section-content">
          <div v-for="(i, k) in section06" :key="k" class="item">
            <div class="img">
              <el-image fit="cover" :src="$common.getResourceUrl(i.image)" />
            </div>
            <div class="name">{{ i.name }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="bottom-line">
        <div>一杯奶茶钱，带你从0基础入门学画画</div>
        <span>
            <i /><i /><i /><i />
        </span>
    </section> -->
  </div>
</template>

<script>
// 轮播图子组件
export default {
  name: 'Index',
  components: {},
  props: {},
  data() {
    return {
      mouseIn: '',

      section02Index: 1,
      section02Timer: null,
      section02: [
        {
          label: '01',
          title: '班主任制定学前规划',
          image: 'pcweb/index/fuwu-01.jpg',
        },
        {
          label: '02',
          title: '插画讲师系统授课',
          image: 'pcweb/index/fuwu-02.jpg',
        },
        {
          label: '03',
          title: '助教老师点评作业',
          image: 'pcweb/index/fuwu-03.jpg',
        },
        {
          label: '04',
          title: '学习管理师在线辅导',
          image: 'pcweb/index/fuwu-04.jpg',
        },
        {
          label: '05',
          title: '课后改画批改作品',
          image: 'pcweb/index/fuwu-05.jpg',
        },
      ],

      section04Index: 0,
      section04Timer: null,
      section04: [
        {
          note: '在这里学习了很多画风，但还是最喜欢儿插了。从原来临摹再到现在原创，都非常感谢老师的耐心指导，如今收获满满，非常开心。',
          head: 'UserHeads/88578/20210824/506939062423126016.jpg',
          name: '陈北玄',
          image: 'pcweb/index/zp-01.jpg',
        },
        {
          note: '我从小是个动漫迷，很喜欢二次元形象，跟着这里的老师学习人物画，感觉每天都有进步。',
          head: 'UserHeads/4/20210726/496338188969705472.jpg',
          name: 'Serendipity',
          image: 'pcweb/index/zp-02.jpg',
        },
        {
          note: '非常喜欢这里的社群氛围，每个人都在积极参与，老师也会监督提醒，大家一起进步，真的是一种享受。',
          head: 'UserHeads/8980/20210626/485411724644581376.jpg',
          name: '摸了个🐟',
          image: 'pcweb/index/zp-05.jpg',
        },
      ],

      section05: [
        {
          icon: 'pcweb/index/wy-01.jpg',
          title: '丰富多元的课程',
          desc: '课程内容涵盖基础、平涂、国朝、q版、厚涂等多种内容，满足不同画风的爱好者需求',
        },
        {
          icon: 'pcweb/index/wy-02.jpg',
          title: '社群实时互动',
          desc: '课程高清视频教学，重点内容提点标注，学员实时社群互动',
        },
        {
          icon: 'pcweb/index/wy-03.jpg',
          title: '陪伴式学习辅导',
          desc: '班主任指定学前规划，主讲老师授课，指导老师点评作业，助教老师在线答疑',
        },
        {
          icon: 'pcweb/index/wy-04.jpg',
          title: '学习时间自主',
          desc: '随时随地，每时每刻，都可以无限观看，课程永久有效。',
        },
      ],

      section06: [
        {
          image: 'pcweb/index/honor_1.jpg',
          name: '讲师作品',
        },
        {
          image: 'pcweb/index/honor_2.jpg',
          name: '讲师作品',
        },
        {
          image: 'pcweb/index/honor_3.jpg',
          name: '讲师作品',
        },
        {
          image: 'pcweb/index/honor_4.jpg',
          name: '讲师作品',
        },
      ],
    }
  },
  computed: {
    scrollTop() {
      return this.$root.$children[0].scrollTop
    },
    pageBarHeight() {
      return this.$refs.pageBar ? parseInt(this.$refs.pageBar.barHeight) : 0
    },
    pageBarBg() {
      return this.scrollTop > this.pageBarHeight ? '#fff' : ''
    },
    pageBarLogoBg() {
      return this.scrollTop > this.pageBarHeight ? '' : '#fff'
    },
    pageBarColor() {
      return this.scrollTop > this.pageBarHeight
        ? 'rgba(0,0,0,0.8)'
        : 'rgba(255,255,255,0.8)'
    },
    loginColor() {
      return this.scrollTop > this.pageBarHeight
        ? '#0e9fff'
        : 'rgba(255,255,255,0.8)'
    },
    activeBarColor() {
      return this.scrollTop > this.pageBarHeight ? '#000' : '#fff'
    },
  },

  mounted() {
    // section02切换
    this.section02Intval()
    this.section04Intval()
  },
  methods: {
    section02Intval(start = true) {
      if (start) {
        if (!this.section02Timer) {
          this.section02Timer = setInterval(() => {
            const index = this.section02Index + 1
            this.section02Index = index > this.section02.length - 1 ? 0 : index
          }, 4000)
        }
      } else {
        if (this.section02Timer) {
          clearInterval(this.section02Timer)
          this.section02Timer = null
        }
      }
    },
    section04Intval(start = true) {
      if (start) {
        if (!this.section04Timer) {
          this.section04Timer = setInterval(() => {
            const index = this.section04Index + 1
            this.section04Index = index > this.section04.length - 1 ? 0 : index
          }, 4000)
        }
      } else {
        if (this.section04Timer) {
          clearInterval(this.section04Timer)
          this.section04Timer = null
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-image__error,
  .el-image__inner,
  .el-image__placeholder {
    background: none;
  }
}
section {
  width: 100%;
  min-width: 1200px;

  .section-main {
    width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  .section-head {
    padding-top: 80px;
    text-align: center;
    .title {
      font-size: 38px;
      color: #202020;
      margin-bottom: 16px;
      line-height: 52px;
      font-weight: bold;

      & > span {
        position: relative;
        .dot {
          position: absolute;
          left: -50px;
          top: 50%;
          width: 28px;
          height: 16px;
          margin-top: -8px;
          transform: skew(6deg);

          &.rev {
            left: unset;
            right: -50px;
            transform: skew(-6deg) rotateY(180deg);
          }

          &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 2px;
            width: 9px;
            height: 11px;
            background-image: linear-gradient(
              180deg,
              rgba(89, 189, 255, 0.2) 0%,
              #66d3f9 100%
            );
            border-radius: 3px;
          }
          &::after {
            content: '';
            position: absolute;
            right: 0px;
            bottom: 0;
            width: 13px;
            height: 16px;
            background: linear-gradient(180deg, #59bdff 0%, #66d3f9 100%);
            border-radius: 3px;
          }
        }
      }
    }
    .desc {
      font-size: 20px;
      color: #666666;
      line-height: 28px;
    }
  }
}

.banner {
  height: 600px;
  background: linear-gradient(180deg, #59bdff 0%, #66d3f9 100%);

  .el-image {
    width: 100%;
    height: 100%;

    ::v-deep {
      .el-image__error,
      .el-image__inner,
      .el-image__placeholder {
        background: none;
        color: #fff;
      }
    }
  }
}

.section-01 {
  background-color: #fff;
  background-size: 100% 100%;
  min-height: 443px;

  .section-content {
    padding-top: 87px;
    padding-bottom: 94px;
    .panel-list {
      display: flex;
      justify-content: space-around;
      & > div {
        text-align: center;

        & > div:first-child {
          font-size: 50px;
          color: #202020;
          line-height: 58px;
          margin-bottom: 7px;
          font-weight: 600;
          > span {
            line-height: 22px;
            font-size: 16px;
            margin-left: 4px;
          }
        }
        & > div:last-child {
          font-size: 16px;
          color: #828282;
        }
      }
    }
  }
}

.section-02 {
  background-color: #f9fcfe;

  .section-content {
    padding-top: 89px;
    padding-bottom: 104px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      width: 386px;
      margin-right: 30px;
      & > div {
        width: 296px;
        height: 90px;
        background-color: #ffffff;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.03);
        border-radius: 12px;
        border: solid 1px #f5f5f5;
        font-size: 22px;
        color: #202020;
        padding-left: 34px;
        line-height: 90px;
        margin-bottom: 30px;

        &:nth-child(1),
        &:nth-child(5) {
          margin-left: 90px;
        }
        &:nth-child(2),
        &:nth-child(4) {
          margin-left: 45px;
        }
        &:last-child {
          margin-bottom: 0;
        }
        &.active {
          color: #fff;
          background-color: #54b3ff;
        }
      }
    }
    .right {
      max-width: calc(100% - 386px);
      width: 796px;
      height: 515px;
      overflow: hidden;
      padding: 24px;

      .el-image {
        &.active {
          display: block;
        }
        display: none;
        width: 100%;
        height: 100%;
        border-radius: 14px;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.03);
      }
    }
  }
}

.section-03 {
  background-color: #fff;
  .section-main {
    padding-bottom: 0;
  }
  .section-content {
    margin-top: 162px;
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .left,
      .right {
        overflow: inherit;
        z-index: 1;
      }
      .left > div,
      .right > div {
        position: relative;
        height: 122px;
        background-color: #ffffff;
        box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        transition: all 0.4s ease-out;
        &:hover {
          transform: scale(1.1);
        }

        .icon {
          width: 80px;
          text-align: center;
          padding-left: 10px;
          .el-image {
            width: 47px;
            height: 47px;
            background: none;
          }
        }
        .main {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-right: 22px;

          & > div:first-child {
            font-size: 24px;
            color: #202020;
            line-height: 33px;
            margin-bottom: 6px;
            font-weight: 600;
          }
          & > div:last-child {
            font-size: 16px;
            color: #666666;
            line-height: 22px;
          }
        }
        &:last-child {
          margin-bottom: 50px;
        }
      }
      .center {
        .el-image {
          width: 100%;
          height: 400px;
          display: block;
          position: relative;
          z-index: 0;
        }
      }
    }

    .bottom-line {
      height: 90px;
      border-radius: 24px 24px 0 0;

      & > div {
        font-size: 32px;
        letter-spacing: 4px;
      }
    }
  }
}

.section-04 {
  background-color: #f9fcfe;
  .section-content {
    display: flex;
    justify-content: space-between;
    padding-top: 85px;
    padding-bottom: 113px;
    .left {
      max-width: calc(100% - 380px - 20px);
      width: 680px;
      height: 568px;

      .el-image {
        &.active {
          display: block;
        }
        display: none;
        width: 100%;
        height: 100%;
      }
    }
    .right {
      width: 380px;
      height: 568px;
      overflow: hidden;

      .list {
        width: 100%;
        height: 100%;

        .item {
          width: 100%;
          padding: 25px 29px;
          border-radius: 8px;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }

          &.active {
            background: #fff;
            box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.03);
            .note {
              color: #000000;
            }
          }

          .note {
            font-size: 15px;
            line-height: 24px;
            letter-spacing: 1px;
            margin-bottom: 12px;
            color: #444444;
          }
          .user {
            display: flex;
            align-items: center;
            .head {
              .el-image {
                width: 32px;
                height: 32px;
                border-radius: 50%;
              }
              margin-right: 10px;
            }
            .name {
              font-size: 14px;
              color: #202020;
            }
          }
        }
      }
    }
  }
}

.section-05 {
  background-color: #fff;

  .section-content {
    padding-top: 85px;
    padding-bottom: 110px;
    display: flex;
    justify-content: space-between;

    .item {
      width: 266px;
      height: 294px;
      border-radius: 10px;
      text-align: center;
      padding: 33px 37px;

      &.active,
      &:hover {
        box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.05);
      }

      .icon {
        padding: 7px 0;
        .el-image {
          width: 70px;
          height: 70px;
        }
        margin-bottom: 20px;
      }
      .title {
        font-size: 24px;
        color: #202020;
        line-height: 33px;
        margin-bottom: 18px;
      }
      .desc {
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }
  }
}

.section-06 {
  background-color: #f9fcfe;

  .section-content {
    padding-top: 85px;
    padding-bottom: 102px;

    display: flex;
    justify-content: space-between;

    .item {
      text-align: center;

      .img {
        width: 275px;
        height: 177px;
        .el-image {
          width: 252px;
          height: 100%;
        }
        margin-bottom: 30px;
      }
      .name {
        font-size: 18px;
        line-height: 28px;
        color: #272c38;
      }
    }
  }
}

.bottom-line {
  width: 100%;
  height: 80px;
  background: linear-gradient(150deg, #0e9fff 0%, #66d3f9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  z-index: 0;

  & > div {
    font-size: 18px;
    letter-spacing: 2px;
    color: #ffffff;
    position: relative;
    z-index: 2;
  }
  & > span > i {
    position: absolute;
    border-radius: 50%;
    box-sizing: border-box;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.1);
    z-index: 1;

    &:nth-child(1) {
      width: 104px;
      height: 104px;
      left: 187px;
      top: -52px;
      border-width: 18px;
    }
    &:nth-child(2) {
      width: 24px;
      height: 24px;
      left: 330px;
      bottom: 2px;
      border-width: 12px;
    }
    &:nth-child(3) {
      width: 63px;
      height: 63px;
      right: 334px;
      top: 46px;
      border-width: 9px;
    }
    &:nth-child(4) {
      width: 130px;
      height: 130px;
      right: 187px;
      top: -40px;
      border-width: 23px;
    }
  }
}
</style>
